import { HttpClient } from "./http";
import type { RequestOptions, SendMessageRequest, SendMessageResponse, JsonValue } from "./types";

export class AiChatWebClient {
  private readonly http: HttpClient;

  constructor(options: RequestOptions) {
    this.http = new HttpClient({
      baseUrl: options.baseUrl,
      apiKey: options.apiKey,
      timeoutMs: options.timeoutMs,
      fetcher: options.fetcher,
    });
  }

  async sendMessage(request: SendMessageRequest): Promise<SendMessageResponse> {
    const payload = {
      agent_id: request.agentId,
      message: request.message,
      conversation_id: request.conversationId ?? null,
      metadata: request.metadata ?? {},
    };

    const response = await this.http.post<{
      success: boolean;
      conversation_id: string | null;
      message: string;
      processing_time: number;
      error?: string;
      metadata?: Record<string, unknown>;
    }>("/api/conversations/send", payload);

    return {
      success: response.success,
      conversationId: response.conversation_id ?? null,
      message: response.message ?? "",
      processingTime: response.processing_time ?? 0,
      error: response.error,
      metadata: response.metadata as Record<string, JsonValue> | undefined,
    };
  }
}
